import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeNames'
})
export class CapitalizeNamesPipe implements PipeTransform {

  constructor() {}

  transform(name: string): string {
    return name.replace(/\b(\w)/g, s => s.toUpperCase());
  }

}
